// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__24S2y","addWidgetButton":"Header_addWidgetButton__2jj5c","dashboardTabs":"Header_dashboardTabs__2gsun","active":"Header_active__3lQl4"};